import React from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon } from 'lucide-react';
import { useWishlist } from '../contexts/WishlistContext';
import { ProductGrid } from '../components/product/ProductGrid';
import { btnPrimary } from '../components/ui/buttonStyles';
import { getProduct } from '../utils/catalog';
import type { Product } from '../types/catalog';
export function Wishlist() {
  const {
    ids
  } = useWishlist();
  const items = ids.map(getProduct).filter((p): p is Product => Boolean(p));
  return <div className="mx-auto max-w-[1440px] px-5 pt-8 md:px-8 md:pt-12" data-id="element-984" data-mp="165r0tt5pf49t">
      <h1 className="font-display text-5xl md:text-7xl" data-id="element-985" data-mp="1b3aeoryhpf18">Favoris</h1>
      <p className="mt-3 max-w-xl text-muted" data-id="element-986" data-mp="1b1pn9b7h2c7l">
        Gardez un œil sur vos coups de cœur — mais ne tardez pas trop : les pièces quittent la boutique avec leur créateur.
      </p>
      <div className="mt-10" data-id="element-987" data-mp="iev189v0b4s0">
        {items.length > 0 ? <ProductGrid products={items} data-id="element-988" data-mp="ndg1uae67qgz" /> : <div className="rounded-sm bg-card px-6 py-20 text-center" data-id="element-989" data-mp="nbv7akruw7j4">
            <HeartIcon className="mx-auto h-7 w-7 text-muted" aria-hidden data-id="element-990" data-mp="injue1f925wn" />
            <p className="mt-4 font-display text-3xl" data-id="element-991" data-mp="dq03o21d80nt">Aucun favori pour l’instant</p>
            <p className="mt-2 text-sm text-muted" data-id="element-992" data-mp="8xqewpbzl6n4">Touchez le cœur d’une pièce pour la retrouver ici.</p>
            <Link to="/boutique" className={`${btnPrimary} mt-6`} data-id="element-993" data-mp="4xgd7ov892e2">
              Parcourir la boutique
            </Link>
          </div>}
      </div>
    </div>;
}